import { reactive } from 'vue';
import { formatDate } from '@/utils/dateHelpers';

import {
  getDefaultValues, getMinsConfigMap, getDateConfigMap,
  getUnitsDescription, getEndsUnitsDescription, getStopsUnitsDescription,
} from '@/utils/settings';

const minsConfigMap = getMinsConfigMap();
const datesBoundConfig = getDateConfigMap();
const fluxUnitsDescription = getUnitsDescription(minsConfigMap);
const endsUnitsDescription = getEndsUnitsDescription(minsConfigMap);
const stopsUnitsDescription = getStopsUnitsDescription(minsConfigMap);

const {
  fluxTracksDefaultMin,
  fluxUsersDefaultMin,
  fluxDefaultUnit,
  endsMin,
  endsDefaultUnit,
  stopsMin,
  stopsDefaultUnit,
} = getDefaultValues(fluxUnitsDescription, endsUnitsDescription, stopsUnitsDescription);

const minDate = datesBoundConfig.get('prnsn_config_earliest_date');
const maxDate = datesBoundConfig.get('prnsn_config_earliest_date');

const store = reactive({
  errorStatus: {
    error: null,
  },
  ecocompteur: {
    active: false,
  },
  suricate: {
    active: false,
    type: '',
    ampleur: '',
    statut: '',
    activite: '',
  },
  display: {
    polyName: null,
    polyId: null,
    itiName: null,
    itiId: null,
    shouldCenter: false,
  },
  unitFilters: {
    minTracksFlux: fluxTracksDefaultMin,
    maxTracksFlux: null,
    minUsersFlux: fluxUsersDefaultMin,
    maxUsersFlux: null,
    minStops: stopsMin,
    maxStops: null,
    minEnds: endsMin,
    maxEnds: null,
  },
  params: {
    countFlux: fluxDefaultUnit,
    countEnds: endsDefaultUnit,
    countStops: stopsDefaultUnit,
    activity: [''],
    windowOpen: formatDate(minDate),
    windowClose: formatDate(maxDate),
    windowOpen2: formatDate(minDate),
    windowClose2: formatDate(maxDate),
    windowOpenExclude: '',
    windowCloseExclude: '',
    time: [''],
    time2: [''],
    yearMin: minDate.getFullYear(),
    yearMax: maxDate.getFullYear(),
    poly: '',
    iti: '',
  },
  itiPolyFolders: {
    textSearch: {
      iti: null,
      poly: null,
    },
    tileDisplay: {
      iti: null,
      poly: null,
    },
  },
  itiTiles: {
    active: false,
  },
  polyTiles: {
    active: false,
  },
  updateErrorState (error) {
    store.errorStatus.error = error;
  },
  updateEcocompteurActive (active) {
    store.ecocompteur.active = active;
  },
  updateSuricateActive (active) {
    store.suricate.active = active;
  },
  updateSuricateType (type) {
    store.suricate.type = type;
  },
  updateSuricateAmpleur (ampleur) {
    store.suricate.ampleur = ampleur;
  },
  updateSuricateStatut (statut) {
    store.suricate.statut = statut;
  },
  updateSuricateActivite (activite) {
    store.suricate.activite = activite;
  },
  updateDisplayedPoly (name, id) {
    store.display.polyName = name;
    store.display.polyId = id;
  },
  updateDisplayedIti (name, id) {
    store.display.itiName = name;
    store.display.itiId = id;
  },
  updateShouldCenterItiPoly (center) {
    store.display.shouldCenter = center;
  },
  updateSearchPolyFolders (folders) {
    store.itiPolyFolders.textSearch.poly = folders;
  },
  updateSearchItiFolders (folders) {
    store.itiPolyFolders.textSearch.iti = folders;
  },
  updateTilesPolyFolders (folders) {
    store.itiPolyFolders.tileDisplay.poly = folders;
  },
  updateTilesItiFolders (folders) {
    store.itiPolyFolders.tileDisplay.iti = folders;
  },
  updateItiTilesActive (status) {
    store.itiTiles.active = status;
  },
  updatePolyTilesActive (status) {
    store.polyTiles.active = status;
  },
  updatePoly (poly) {
    store.params.poly = poly;
  },
  updateIti (iti) {
    store.params.iti = iti;
  },
  updateMinTracksFlux (min) {
    store.unitFilters.minTracksFlux = min;
  },
  updateMaxTracksFlux (max) {
    store.unitFilters.maxTracksFlux = max;
  },
  updateMinUsersFlux (min) {
    store.unitFilters.minUsersFlux = min;
  },
  updateMaxUsersFlux (max) {
    store.unitFilters.maxUsersFlux = max;
  },
  updateMinStops (min) {
    store.unitFilters.minStops = min;
  },
  updateMaxStops (max) {
    store.unitFilters.maxStops = max;
  },
  updateMinEnds (min) {
    store.unitFilters.minEnds = min;
  },
  updateMaxEnds (max) {
    store.unitFilters.maxEnds = max;
  },
  updateCountFlux (count) {
    store.params.countFlux = count;
  },
  updateCountEnds (count) {
    store.params.countEnds = count;
  },
  updateCountStops (count) {
    store.params.countStops = count;
  },
  updateActivity (activity) {
    store.params.activity = activity;
  },
  updateWindowOpen (windowOpen) {
    store.params.windowOpen = windowOpen;
  },
  updateWindowClose (windowClose) {
    store.params.windowClose = windowClose;
  },
  updateWindowOpen2 (windowOpen) {
    store.params.windowOpen2 = windowOpen;
  },
  updateWindowClose2 (windowClose) {
    store.params.windowClose2 = windowClose;
  },
  updateWindowOpenExclude (windowOpenExclude) {
    store.params.windowOpenExclude = windowOpenExclude;
  },
  updateWindowCloseExclude (windowCloseExclude) {
    store.params.windowCloseExclude = windowCloseExclude;
  },
  updateTime (time) {
    store.params.time = time;
  },
  updateTime2 (time) {
    store.params.time2 = time;
  },
  updateYearMin (yearMin) {
    store.params.yearMin = yearMin;
  },
  updateYearMax (yearMax) {
    store.params.yearMax = yearMax;
  },
});

export { store as default };
